import * as React from "react";
import styled from "../../styles";
import theme from "../../styles/theme";

type colors = typeof theme.color.typography;

const NameIconSVG = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="12"
    viewBox="0 0 10 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M1.06836 11.0371C0.755859 11.0371 0.509766 10.9668 0.330078 10.8262C0.154297 10.6895 0.0664062 10.5 0.0664062 10.2578C0.0664062 9.87891 0.179688 9.48242 0.40625 9.06836C0.632812 8.65039 0.960938 8.25977 1.39062 7.89648C1.82031 7.5293 2.33789 7.23242 2.94336 7.00586C3.55273 6.77539 4.23633 6.66016 4.99414 6.66016C5.75586 6.66016 6.43945 6.77539 7.04492 7.00586C7.6543 7.23242 8.17188 7.5293 8.59766 7.89648C9.02734 8.25977 9.35547 8.65039 9.58203 9.06836C9.8125 9.48242 9.92773 9.87891 9.92773 10.2578C9.92773 10.5 9.83789 10.6895 9.6582 10.8262C9.48242 10.9668 9.23828 11.0371 8.92578 11.0371H1.06836ZM5 5.61133C4.58203 5.61133 4.19531 5.49805 3.83984 5.27148C3.48438 5.04102 3.19727 4.73242 2.97852 4.3457C2.76367 3.95508 2.65625 3.51758 2.65625 3.0332C2.65625 2.55664 2.76367 2.12695 2.97852 1.74414C3.19727 1.36133 3.48438 1.05859 3.83984 0.835938C4.19531 0.613281 4.58203 0.501953 5 0.501953C5.41797 0.501953 5.80469 0.611328 6.16016 0.830078C6.51562 1.04883 6.80078 1.34961 7.01562 1.73242C7.23438 2.11133 7.34375 2.54102 7.34375 3.02148C7.34375 3.50977 7.23438 3.94922 7.01562 4.33984C6.80078 4.73047 6.51562 5.04102 6.16016 5.27148C5.80469 5.49805 5.41797 5.61133 5 5.61133Z"
      fill="black"
    />
  </svg>
);

interface Props {
  colorPreset?: keyof colors;
}

export const NameIcon = styled(NameIconSVG)<Props>`
  path {
    fill: ${(p) =>
      p.colorPreset ? p.theme.color.typography[p.colorPreset] : "#fff"};
  }
`;
